import { Component, ElementRef, OnInit, Renderer2, ViewChild, AfterViewInit, Inject, ChangeDetectorRef } from '@angular/core';

import { MenuService } from '@services/outros/menu.service';
import { UserLoginModel } from '@models/outros/user-login.model';
import { UserControllerService } from '@services/outros/user-controller.service';
import { DOCUMENT } from '@angular/common';
import { MenuConfigModel } from '@core/models/outros/menu-config.model';
import { Toast } from '@core/services/outros/toast.service';
import { RolePermissionService } from '@core/services/apis/identidade/role-permission.service';
import { PermissionStorageModel, UserPermissionsService } from '@core/services/outros/user-permissions.service';
import { RoleModel } from '@core/models/identidade/role.model';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {

  @ViewChild('menu') menu: ElementRef;
  @ViewChild('menuBox') menuBox: ElementRef;
  @ViewChild('menuRelative') menuRelative: ElementRef;

  menuItems: MenuConfigModel[] = new Array<MenuConfigModel>();
  panelOpenState = false;
  show: boolean = false;
  user: UserLoginModel;
  firstName: string;
  currentId: string;
  isStudant: boolean = false;

  roles: RoleModel[] = new Array<RoleModel>();
  allRoles: RoleModel[] = new Array<RoleModel>();
  roleSelect: UntypedFormControl = new UntypedFormControl(new RoleModel());


  constructor(
    private _userService: UserControllerService,
    private _renderer: Renderer2,
    private _menuService: MenuService,
    private _cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) document,
    private _toastService: Toast,
    private _rolePermission: RolePermissionService,
    private _userPermission: UserPermissionsService
  ) { }

  ngOnInit(): void {
    this.user = this._userService.getUserLogged();
    this.isStudant = this._userService.isStudent()
    this.firstName = this.user.name.split(' ')[0];
    let role: RoleModel = new RoleModel();
    if (this._userService.getUserLogged().roles.length > 0) {
      this.roles = this._userService.getUserLogged().roles;
      role = this.roles.find(x => x.name == this._userService.getUserLogged().type);
    } else {
      this.roles = this._userPermission.getRoleList().filter(x => x.name == this._userService.getUserLogged().type);
      role = this._userPermission.getRoleList().find(x => x.name == this._userService.getUserLogged().type);
    }
    this.roleSelect.setValue(role);
    this._observChangeRole();
  }

  ngAfterViewInit(): void {
    this._menuService.getMenuAtual().subscribe((res) => {
      if (res) {
        this.menuItems = res;
        this._cdr.detectChanges();
      }
      setTimeout(() => {
        const el = this.menuRelative.nativeElement.offsetHeight + 50;
        this._renderer.setStyle(this.menuBox.nativeElement, 'height', `${el}px`);
      }, 100);
    });
  }

  openMenu(): void {
    this._renderer.setStyle(this.menu.nativeElement, 'top', 0);
  }

  closeMenu(element?): void {
    if (!element) {
      this._renderer.setStyle(this.menu.nativeElement, 'top', '-200vh');
    } else if (element.target && element.target.id !== 'menu') {
      return
    }
    this._renderer.setStyle(this.menu.nativeElement, 'top', '-200vh');
  }

  logout(): void {
    this._userService.logout();
  }


  openLink(url) {
    window.open(url, '_blank').focus();
  }

  showMenu(): void {
    this.show = Object.assign(false, true);
  }

  accessTeleClass(): void {
    window.open('https://cfcvirtual.startbio.com.br/', '_blank').focus();
  }

  expandMenu(id) {
    let itens = this.menuItems.find(x => x.id == id);
    let quantidade = itens.submenus.length * 40;

    if (this.currentId == id) {
      this._renderer.setStyle(document.getElementById(this.currentId), 'height', '35px');
      this.currentId = null;
      return
    }
    if (this.currentId) {
      this._renderer.setStyle(document.getElementById(this.currentId), 'height', '35px');
      this._renderer.setStyle(document.getElementById(id), 'height', `${quantidade}px`);
      this.currentId = id;
    } else {
      this._renderer.setStyle(document.getElementById(id), 'height', `${quantidade}px`);
      this.currentId = id;
    }
  }

  private _observChangeRole(): void {
    this.roleSelect.valueChanges.subscribe(
      (res) => {
        if (res) {
          let user = this._userService.getUserLogged();
          user.type = res.name;
          this._rolePermission.getAll({ roleId: res.id }).subscribe(
            (permissions) => {
              this._userService.setUser(user);
              let permissionStorage: PermissionStorageModel = new PermissionStorageModel();
              permissionStorage.permissions = permissions;
              this._userPermission.setPermissionsSubject(permissions);
              this._userPermission.setPermissionsStorage(permissionStorage);
              this._menuService.setMenu();
              this._toastService.success('Sucesso', `Perfil alterado com sucesso para ${user.type}`);
            }
          )
        }
      }
    )
  }
}
